// @ts-ignore
import { useEffect } from "react";

import { PreloadedQuery } from "react-relay";
import { UserLocale } from "src/utils/useGeoCurrency";

import FeatureGates from "@atlaskit/feature-gate-js-client";

import { pricingPageRelayQuery } from "@/__generated_contentful__/pricingPageRelayQuery.graphql";
import { PricingContentContextProviderRelay } from "@/components/wpl/pricing/src/pricing-content-context.tsx";
import { IntercomProvider } from "@/libraries/intercom/src";
import { JiraSoftwarePricingPageV2Template } from "@/templates/software/jira/pricing/index.ts";
import { experiments, useExperimentExposure } from "@/utils/experiment";
import { PricingContent } from "@/utils/pricing-queries/get-pricing-content";

import { AppPricingData } from "../../../../contentful";

export type JiraSoftwarePricingPageProps = {
    pricing?: AppPricingData;
    countryCode?: UserLocale;
    pricingContent?: PricingContent;
    queryRef?: PreloadedQuery<pricingPageRelayQuery>;
};

export const JiraSoftwarePricingPageRelay = ({
    pricing,
    countryCode,
    pricingContent,
    queryRef
}: JiraSoftwarePricingPageProps) => {
    const [cpapiDeprecationExposureFired, fireCpapiDeprecationExposure] =
        useExperimentExposure(
            experiments.cpapiDeprecationPricingJiraExperiment
        );

    useEffect(() => {
        if (!cpapiDeprecationExposureFired) {
            fireCpapiDeprecationExposure();
        }
    }, [cpapiDeprecationExposureFired, fireCpapiDeprecationExposure]);

    // FYI, this is currently JA only, since we only have JA work space appId
    const isBootIntercom: boolean = FeatureGates.checkGate(
        "gwp-737-enable-intercom-chat-jsw"
    );

    const [
        pricingDirectBuyCheckoutAaFired,
        pricingDirectBuyCheckoutfireExposureAa
    ] = useExperimentExposure(experiments.pricingDirectBuyCheckoutAA);

    useEffect(() => {
        if (!pricingDirectBuyCheckoutAaFired) {
            pricingDirectBuyCheckoutfireExposureAa();
        }
    }, [
        pricingDirectBuyCheckoutAaFired,
        pricingDirectBuyCheckoutfireExposureAa
    ]);

    return (
        <IntercomProvider appId={"p0ww63i2"} triggerBoot={isBootIntercom}>
            <PricingContentContextProviderRelay
                productId="jira-software"
                pricingContent={pricingContent}
                queryRef={queryRef}
            >
                <div>
                    <JiraSoftwarePricingPageV2Template
                        pricing={pricing}
                        countryCode={countryCode}
                    />
                </div>
            </PricingContentContextProviderRelay>
        </IntercomProvider>
    );
};
